import React from "react";

export const Logo = ({ size = "md", className = "", variant = "light" }) => {
  const sizes = {
    sm: "text-lg",
    md: "text-2xl",
    lg: "text-4xl",
    xl: "text-5xl sm:text-6xl",
  };
  const navy = variant === "dark" ? "#FFFFFF" : "#1B3A6B";
  return (
    <div
      className={`font-display font-bold tracking-tight ${sizes[size]} ${className}`}
      data-testid="lab-logo"
    >
      <span style={{ color: navy }}>Locar</span>
      <span style={{ color: "#F97316" }}> Ativo </span>
      <span style={{ color: navy }}>Brasil</span>
    </div>
  );
};
